import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
import { IniInfo } from "system/types/interfaces";
import { EditRegular } from "@fluentui/react-icons";

interface PendingChangesModalProps {
  open: boolean;
  onClose: () => void;
  modifiedRules: { index: number; rule: IniInfo }[];
  onNavigate: (rule: IniInfo, index: number) => void;
}

const PendingChangesModal: React.FC<PendingChangesModalProps> = ({ open, onClose, modifiedRules, onNavigate }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Rule Changes</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Applicability rules with pending changes. Review or edit them as needed. Changes made in the other tabs, and to the
          Library, are counted separately in the Pending Changes total at the top of the page.
        </Typography>
        <List>
          {modifiedRules.map(({ index, rule }) => (
            <ListItem
              key={index}
              divider
              secondaryAction={
                <IconButton edge="end" onClick={() => onNavigate(rule, index)} color="primary">
                  <EditRegular fontSize={22} />
                </IconButton>
              }
            >
              <ListItemText
                primary={
                  <Typography variant="body2" color="text.primary">
                    <strong>{`${index + 1}: ${rule.name.toLowerCase().includes("-comment-") ? "" : rule.name} ${rule.delimiter} ${rule.value}`}</strong>
                  </Typography>
                }
                primaryTypographyProps={{ color: "text.primary" }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PendingChangesModal;
